import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const homeAPI = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getBannerData: builder.query({
      query: () => `banners/list-banners`,
    }),
    getBrandsData: builder.query({
      query: () => `brands/list-active-brands`,
    }),
    getBrandStatus: builder.query({
      query: () => `brands/brand-bar-status`,
    }),
    gethomesections: builder.query({
      query: () => `home-sections`,
    }),
    getProductDetails: builder.query({
      query: () => `home-static`,
    }),
  }),
});

export const { 
  useGetBannerDataQuery, 
  useGetBrandsDataQuery, 
  useGetBrandStatusQuery, 
  useGethomesectionsQuery, 
  useGetProductDetailsQuery 
} = homeAPI;
